(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMoments(root) {
    if (root.dataset.crMomentsReady === 'true') return;
    root.dataset.crMomentsReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cr-moment-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cr-moment-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(index, focusTab) {
      var nextIndex = Math.max(0, Math.min(index, tabs.length - 1));
      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === nextIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === nextIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
      if (focusTab) tabs[nextIndex].focus();
      tabs[nextIndex].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false);
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(nextIndex, true);
      });
    });

    root.addEventListener('shopify:block:select', function (event) {
      var blockId = event.detail && event.detail.blockId;
      var index = tabs.findIndex(function (tab) {
        return tab.dataset.blockId === blockId;
      });
      if (index >= 0) activate(index, false);
    });

    activate(0, false);
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches('[data-cr-moments]')) initMoments(scope);
    (scope || document).querySelectorAll('[data-cr-moments]').forEach(initMoments);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-combo-banner-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-cr-combo-banner]';

  function init(root) {
    if (!root || root.dataset.crComboBannerReady === 'true') return;
    root.dataset.crComboBannerReady = 'true';

    var track = root.querySelector('[data-cr-combo-banner-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cr-combo-banner-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cr-combo-banner-dot]'));
    var prev = root.querySelector('[data-cr-combo-banner-prev]');
    var next = root.querySelector('[data-cr-combo-banner-next]');
    var status = root.querySelector('[data-cr-combo-banner-status]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reducedMotion && slides.length > 1;
    var interval = Math.max(3000, parseInt(root.dataset.interval, 10) || 5500);
    var current = 0;
    var timer = null;
    var scrollFrame = null;

    if (!track || slides.length < 2) return;

    function announce(index) {
      if (status) status.textContent = 'Banner ' + (index + 1) + ' de ' + slides.length;
    }

    function setActive(index, shouldAnnounce) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (shouldAnnounce) announce(current);
    }

    function goTo(index, shouldAnnounce) {
      var target = (index + slides.length) % slides.length;
      slides[target].scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      setActive(target, shouldAnnounce);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || document.hidden) return;
      timer = window.setInterval(function () {
        goTo(current + 1, false);
      }, interval);
    }

    function restart() {
      stop();
      start();
    }

    track.addEventListener('scroll', function () {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        var left = track.scrollLeft;
        var nearest = 0;
        var distance = Infinity;
        slides.forEach(function (slide, index) {
          var nextDistance = Math.abs(slide.offsetLeft - left);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });
        setActive(nearest, false);
      });
    }, { passive: true });

    track.addEventListener('pointerdown', stop, { passive: true });
    track.addEventListener('pointerup', restart, { passive: true });
    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', start);

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(current - 1, true);
        restart();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(current + 1, true);
        restart();
      }
    });

    if (prev) prev.addEventListener('click', function () {
      goTo(current - 1, true);
      restart();
    });

    if (next) next.addEventListener('click', function () {
      goTo(current + 1, true);
      restart();
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.crComboBannerDot, 10) || 0, true);
        restart();
      });
    });

    function onVisibilityChange() {
      if (document.hidden) stop();
      else start();
    }
    document.addEventListener('visibilitychange', onVisibilityChange);
    root.crComboBannerCleanup = function () {
      stop();
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = null;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      root.crComboBannerCleanup = null;
    };

    setActive(0, false);
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(SELECTOR).forEach(function (root) {
      if (root.crComboBannerCleanup) root.crComboBannerCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-combo-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCombo(root){
    if(!root||root.dataset.legacyInitialized==='true')return;
    root.dataset.legacyInitialized='true';

    var sectionRoot=root.closest('.shopify-section');
    if(root.dataset.hidePreviousVisual==='true'&&sectionRoot){
      var previous=sectionRoot.previousElementSibling;
      if(previous&&!/header|announcement/i.test(previous.id+' '+previous.className))previous.hidden=true;
    }

    var dialogs=[].slice.call(root.querySelectorAll('[data-cr-quick-dialog]'));
    var cartbar=root.querySelector('[data-cr-cartbar]');
    var viewCart=root.querySelector('[data-cr-view-cart]');
    var cartItems=root.querySelector('[data-cr-cart-items]');
    var cartTotal=root.querySelector('[data-cr-cart-total]');
    var toast=root.querySelector('[data-cr-toast]');
    var ladder=root.querySelector('[data-cr-ladder]');
    var marks=[].slice.call(root.querySelectorAll('[data-cr-mark]')).sort(function(a,b){return(parseFloat(a.dataset.value)||0)-(parseFloat(b.dataset.value)||0)});
    var marksWrap=root.querySelector('[data-cr-marks]');
    var currency=root.dataset.currency||'BRL';
    var adding=false;
    var toastTimer=0;
    var viewCartLabel=viewCart?viewCart.textContent.replace(/\s*\(\d+\)$/,''):'Ver carrinho';

    marks.forEach(function(mark){if(marksWrap)marksWrap.appendChild(mark)});
    if(marksWrap)marksWrap.style.setProperty('--reward-count',Math.max(1,marks.length));

    function money(cents){
      try{return new Intl.NumberFormat('pt-BR',{style:'currency',currency:currency}).format((Number(cents)||0)/100)}
      catch(error){return'R$ '+((Number(cents)||0)/100).toFixed(2).replace('.',',')}
    }

    function quantity(row){return parseInt(row.dataset.qty,10)||0}

    function dialogTotals(dialog){
      var units=0,cents=0;
      dialog.querySelectorAll('[data-cr-flavor]').forEach(function(row){var qty=quantity(row);units+=qty;cents+=qty*(parseInt(row.dataset.price,10)||0)});
      return{units:units,cents:cents};
    }

    function showMedia(dialog,mediaId,imageUrl){
      var gallery=dialog.querySelector('[data-cr-qv-gallery]');
      if(!gallery)return;
      var slides=[].slice.call(gallery.querySelectorAll('[data-cr-qv-slide]'));
      var thumbs=[].slice.call(gallery.querySelectorAll('[data-cr-qv-thumb]'));
      if(!slides.length)return;
      var normalize=function(value){return(value||'').replace(/^https?:/,'').split('?')[0]};
      var wanted=slides.findIndex(function(slide){return mediaId&&slide.dataset.mediaId===String(mediaId)});
      if(wanted<0&&imageUrl){var normalized=normalize(imageUrl);wanted=slides.findIndex(function(slide){return normalize(slide.dataset.imageUrl)===normalized})}
      if(wanted<0)return;
      slides.forEach(function(slide,index){var active=index===wanted;slide.hidden=!active;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true')});
      thumbs.forEach(function(thumb,index){var active=index===wanted;thumb.classList.toggle('is-active',active);thumb.setAttribute('aria-current',active?'true':'false')});
      var viewport=gallery.querySelector('[data-cr-qv-viewport]');
      if(viewport)viewport.dataset.crGalleryIndex=String(wanted);
    }

    function renderDialog(dialog){
      var total=dialogTotals(dialog);
      dialog.querySelectorAll('[data-cr-flavor]').forEach(function(row){
        var qty=quantity(row),qtyEl=row.querySelector('[data-cr-variant-qty]'),minus=row.querySelector('[data-cr-variant-minus]');
        if(qtyEl)qtyEl.textContent=qty;
        if(minus)minus.disabled=qty===0||row.classList.contains('is-unavailable');
        row.classList.toggle('has-items',qty>0);
      });
      var add=dialog.querySelector('[data-cr-add]');
      if(!add)return;
      add.setAttribute('aria-busy',adding?'true':'false');
      add.disabled=adding||total.units===0;
      if(adding){add.textContent='Adicionando…';return}
      if(total.units===0){add.textContent='Adicionar ao carrinho';return}
      add.textContent=(root.dataset.addLabel||'Adicionar')+' '+total.units+(total.units===1?' item':' itens')+' • '+money(total.cents);
    }

    function showToast(message){
      if(!toast)return;
      window.clearTimeout(toastTimer);
      toast.textContent=message;
      toast.hidden=false;
      window.requestAnimationFrame(function(){toast.classList.add('is-visible')});
      toastTimer=window.setTimeout(function(){toast.classList.remove('is-visible');window.setTimeout(function(){toast.hidden=true},220)},3000);
    }

    function renderBenefits(cents,itemCount){
      if(!ladder||root.dataset.showBenefits!=='true'||itemCount<1||!marks.length){if(ladder)ladder.hidden=true;return}
      ladder.hidden=false;
      var max=Math.max.apply(null,marks.map(function(mark){return(parseFloat(mark.dataset.value)||0)*100}));
      var next=null,reached=0;
      marks.forEach(function(mark){
        var target=(parseFloat(mark.dataset.value)||0)*100;
        var ok=cents>=target;
        mark.dataset.reached=ok?'true':'false';
        var state=mark.querySelector('[data-cr-benefit-state]');
        if(state){var custom=ok?mark.dataset.unlockedText:mark.dataset.lockedText;state.textContent=custom||(ok?'Benefício liberado':'Libera em '+money(target))}
        if(ok)reached+=1;else if(!next)next={mark:mark,target:target};
      });
      var percent=Math.max(0,Math.min(100,max?cents/max*100:0));
      var fill=root.querySelector('[data-cr-ladder-fill]');
      var progress=root.querySelector('[data-cr-progress]');
      if(fill)fill.style.width=percent+'%';
      if(progress)progress.setAttribute('aria-valuenow',String(Math.round(percent)));
      var message=root.querySelector('[data-cr-next-msg]'),sub=root.querySelector('[data-cr-next-sub]');
      if(!message)return;
      if(next){
        var name=next.mark.querySelector('b').textContent.trim();
        message.textContent='Faltam '+money(Math.max(0,next.target-cents))+' para liberar '+name+'.';
        if(sub)sub.textContent=reached?reached+(reached===1?' benefício conquistado.':' benefícios conquistados.'):'Continue montando do seu jeito.';
      }else{
        message.textContent=root.dataset.allBenefits||'Todos os benefícios foram desbloqueados.';
        if(sub)sub.textContent='Seu combo chegou ao último marco.';
      }
    }

    function updateHeaderCartCount(count){
      document.querySelectorAll('[data-cart-count],.cart-count-bubble span[aria-hidden="true"],.cart-count-bubble span:first-child,[data-cr-cart-count] .cr-nav__badge').forEach(function(node){node.textContent=count;node.hidden=count<1});
    }

    function updateCart(cart){
      if(!cart)return;
      var count=Number(cart.item_count)||0,total=Number(cart.total_price)||0,hasItems=count>0;
      if(cartbar)cartbar.hidden=!hasItems;
      root.classList.toggle('has-cart-actions',hasItems);
      /* The inline builder owns its fixed-bar spacing. */
      if(cartItems)cartItems.textContent=count+(count===1?' item':' itens');
      if(cartTotal)cartTotal.textContent=money(total);
      if(viewCart)viewCart.textContent=viewCartLabel+' ('+count+')';
      updateHeaderCartCount(count);
      renderBenefits(total,count);
    }

    function closeQuick(dialog){
      if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');
      if(!document.querySelector('.cr-qv[open]'))document.documentElement.style.overflow='';
    }

    function addDialog(dialog){
      var items=[];
      dialog.querySelectorAll('[data-cr-flavor]').forEach(function(row){var qty=quantity(row);if(qty>0)items.push({id:Number(row.dataset.variantId),quantity:qty})});
      if(!items.length||adding)return;
      var errorEl=dialog.querySelector('[data-cr-error]');
      adding=true;
      if(errorEl)errorEl.hidden=true;
      renderDialog(dialog);
      if(!window.CocoRockCart||typeof window.CocoRockCart.addItems!=='function'){
        adding=false;if(errorEl){errorEl.textContent='O carrinho ainda está carregando. Tente novamente.';errorEl.hidden=false}renderDialog(dialog);return;
      }
      window.CocoRockCart.addItems(items,dialog.querySelector('[data-cr-add]'),'cr-combo-builder')
        .then(function(cart){
          dialog.querySelectorAll('[data-cr-flavor]').forEach(function(row){row.dataset.qty='0'});
          adding=false;
          renderDialog(dialog);
          closeQuick(dialog);
          updateCart(cart);
          showToast(root.dataset.addedMessage||'Adicionado ao carrinho ✓');
        })
        .catch(function(error){adding=false;if(errorEl){errorEl.textContent=error.message||'Não foi possível adicionar. Tente novamente.';errorEl.hidden=false}renderDialog(dialog)});
    }

    function openDrawer(){
      if(!window.CocoRockCart||typeof window.CocoRockCart.open!=='function'){showToast('O carrinho ainda está carregando. Tente novamente.');return}
      if(viewCart)viewCart.setAttribute('aria-busy','true');
      window.CocoRockCart.open(viewCart).catch(function(){showToast('Não foi possível abrir o carrinho. Tente novamente.')}).finally(function(){if(viewCart)viewCart.setAttribute('aria-busy','false')});
    }

    root.addEventListener('click',function(event){
      var plus=event.target.closest('[data-cr-variant-plus]');
      var minus=event.target.closest('[data-cr-variant-minus]');
      if(plus||minus){
        var row=(plus||minus).closest('[data-cr-flavor]');
        var dialog=row.closest('[data-cr-quick-dialog]');
        var next=Math.max(0,Math.min(99,quantity(row)+(plus?1:-1)));
        row.dataset.qty=String(next);
        if(plus)showMedia(dialog,row.dataset.mediaId,row.dataset.imageUrl);
        renderDialog(dialog);
        return;
      }
      var add=event.target.closest('[data-cr-add]');
      if(add){addDialog(add.closest('[data-cr-quick-dialog]'));return}
    });

    dialogs.forEach(function(dialog){
      renderDialog(dialog);
      dialog.addEventListener('close',function(){if(!document.querySelector('.cr-qv[open]'))document.documentElement.style.overflow=''});
    });

    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(response){return response.ok?response.json():null}).then(updateCart).catch(function(){});
  }

  document.querySelectorAll('[data-cr-combo]').forEach(initCombo);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-cr-combo]').forEach(initCombo)});
  document.addEventListener('shopify:section:unload',function(event){if(event.target.querySelector('[data-cr-combo]'))document.body.classList.remove('cr-combo-cartbar-visible')});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-footer"]) return;
  try {
    
/* Só isto: no desktop os <details> ficam sempre abertos (viram colunas);
   no mobile voltam a ser acordeão. Sem lib, sem observar scroll. */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function sync() {
    document.querySelectorAll('.cr-footer__col').forEach(function (el) {
      if (mq.matches) { el.open = true; }
      else { el.open = false; }
    });
  }
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
  document.addEventListener('shopify:section:load', sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-header"]) return;
  try {
    
(function () {
  function init(header) {
    if (!header || header.dataset.crHeaderReady === 'true') return;
    header.dataset.crHeaderReady = 'true';
    var button = header.querySelector('[data-cr-menu-open]');
    if (!button) return;
    function close(restoreFocus) {
      header.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Abrir menu');
      if (restoreFocus) button.focus();
    }
    button.addEventListener('click', function () {
      var open = !header.classList.contains('is-open');
      header.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
    });
    header.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-open')) close(true);
    });
    function onOutsideClick(event) {
      if (header.classList.contains('is-open') && !header.contains(event.target)) close(false);
    }
    document.addEventListener('click', onOutsideClick);
    header.crHeaderCleanup = function () { document.removeEventListener('click', onOutsideClick); header.crHeaderCleanup = null; };
  }
  document.querySelectorAll('[data-cr-custom-header]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-cr-custom-header]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-cr-custom-header]').forEach(function (header) { if (header.crHeaderCleanup) header.crHeaderCleanup(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(hero) {
    if (hero.dataset.crHeroReady === 'true') return;
    hero.dataset.crHeroReady = 'true';

    var viewport = hero.querySelector('[data-cr-hero-viewport]');
    var track = hero.querySelector('[data-cr-hero-track]');
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-cr-slide]'));
    var dotsWrap = hero.querySelector('[data-cr-hero-dots]');
    var prevButton = hero.querySelector('[data-cr-hero-prev]');
    var nextButton = hero.querySelector('[data-cr-hero-next]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplayEnabled = hero.dataset.crAutoplay === 'true';
    var autoplayDelay = parseInt(hero.dataset.crAutoplayDelay, 10) || 5500;
    var activeIndex = 0;
    var autoplayTimer = null;
    var selectedBlockId = null;
    var pointerId = null;
    var startX = 0;
    var deltaX = 0;
    var viewportWidth = 0;
    var didDrag = false;
    var lastMoveX = 0;
    var lastMoveT = 0;
    var velocity = 0;

    if (!viewport || !track || slides.length === 0) return;

    function stopAutoplay() {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || reducedMotion.matches || selectedBlockId || slides.length < 2 || document.hidden) return;
      autoplayTimer = window.setTimeout(function () {
        goTo(activeIndex + 1);
        startAutoplay();
      }, autoplayDelay);
    }

    function render(animate) {
      if (!animate) track.classList.add('is-dragging');
      track.style.transform = 'translate3d(-' + (activeIndex * 100) + '%,0,0)';
      slides.forEach(function (slide, index) {
        var isActive = index === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (slide.tagName === 'A') {
          if (isActive) slide.removeAttribute('tabindex');
          else slide.setAttribute('tabindex', '-1');
        }
      });
      if (dotsWrap) {
        dotsWrap.querySelectorAll('button').forEach(function (dot, index) {
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }
      if (!animate) {
        window.requestAnimationFrame(function () {
          track.classList.remove('is-dragging');
        });
      }
    }

    function goTo(nextIndex, animate) {
      activeIndex = (nextIndex + slides.length) % slides.length;
      render(animate !== false);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Mostrar banner ' + (index + 1) + ' de ' + slides.length);
        dot.addEventListener('click', function () {
          goTo(index);
          restartAutoplay();
        });
        dotsWrap.appendChild(dot);
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(activeIndex - 1);
        restartAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(activeIndex + 1);
        restartAutoplay();
      });
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      deltaX = 0;
      didDrag = false;
      velocity = 0;
      lastMoveX = event.clientX;
      lastMoveT = performance.now();
      viewportWidth = viewport.clientWidth;
      stopAutoplay();
    });

    viewport.addEventListener('pointermove', function (event) {
      if (event.pointerId !== pointerId) return;
      deltaX = event.clientX - startX;
      var moveT = performance.now();
      velocity = 0.8 * ((event.clientX - lastMoveX) / Math.max(1, moveT - lastMoveT)) + 0.2 * velocity;
      lastMoveX = event.clientX;
      lastMoveT = moveT;
      if (Math.abs(deltaX) < 6) return;
      if (!didDrag && !viewport.hasPointerCapture(pointerId)) viewport.setPointerCapture(pointerId);
      didDrag = true;
      viewport.classList.add('is-dragging');
      track.classList.add('is-dragging');
      track.style.transform = 'translate3d(calc(-' + (activeIndex * 100) + '% + ' + deltaX + 'px),0,0)';
    });

    function finishDrag(event) {
      if (event.pointerId !== pointerId) return;
      if (viewport.hasPointerCapture(pointerId)) viewport.releasePointerCapture(pointerId);
      pointerId = null;
      viewport.classList.remove('is-dragging');
      track.classList.remove('is-dragging');
      var threshold = Math.max(40, viewportWidth * 0.15);
      /* gesto rápido (flick) troca de banner mesmo com arrasto curto */
      var flick = Math.abs(velocity) > 0.45 && Math.abs(deltaX) > 24;
      if (deltaX <= -threshold || (flick && velocity < 0)) goTo(activeIndex + 1);
      else if (deltaX >= threshold || (flick && velocity > 0)) goTo(activeIndex - 1);
      else render(true);
      restartAutoplay();
      window.setTimeout(function () {
        didDrag = false;
      }, 0);
    }

    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);
    viewport.addEventListener('click', function (event) {
      if (didDrag) {
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      }
    }, true);

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);
    hero.addEventListener('focusin', stopAutoplay);
    hero.addEventListener('focusout', startAutoplay);

    hero.addEventListener('shopify:block:select', function (event) {
      var blockId = event.detail && event.detail.blockId;
      var index = slides.findIndex(function (slide) {
        return slide.dataset.blockId === blockId;
      });
      if (index < 0) return;
      selectedBlockId = blockId;
      stopAutoplay();
      goTo(index, false);
    });

    hero.addEventListener('shopify:block:deselect', function (event) {
      var blockId = event.detail && event.detail.blockId;
      if (!selectedBlockId || (blockId && selectedBlockId !== blockId)) return;
      selectedBlockId = null;
      startAutoplay();
    });

    function onVisibilityChange() {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    }
    function onReducedMotionChange() {
      if (reducedMotion.matches) stopAutoplay();
      else startAutoplay();
    }
    document.addEventListener('visibilitychange', onVisibilityChange);
    reducedMotion.addEventListener('change', onReducedMotionChange);
    hero.crHeroCleanup = function () {
      stopAutoplay();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      reducedMotion.removeEventListener('change', onReducedMotionChange);
      hero.crHeroCleanup = null;
    };

    render(false);
    startAutoplay();
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches('[data-cr-hero]')) initHero(scope);
    (scope || document).querySelectorAll('[data-cr-hero]').forEach(initHero);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-cr-hero]').forEach(function (hero) {
      if (hero.crHeroCleanup) hero.crHeroCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-nutrition"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.crNutriReady) return;
    root.dataset.crNutriReady = 'true';
    var data;
    try { data = JSON.parse(root.querySelector('[data-cr-nutri-data]').textContent); } catch (e) { return; }
    if (!data.length) return;
    var keyOf = function (d) { return d.handle || d.product; };
    var products = [];
    data.forEach(function (d) { if (products.indexOf(keyOf(d)) === -1) products.push(keyOf(d)); });
    var state = { product: products[0], flavor: null };
    var tabsEl = root.querySelector('[data-cr-nutri-tabs]');
    var varsEl = root.querySelector('[data-cr-nutri-variants]');
    function flavorsOf(p) { return data.filter(function (d) { return keyOf(d) === p; }); }
    function current() { var list = flavorsOf(state.product); return list.find(function (d) { return d.flavor === state.flavor; }) || list[0]; }
    function renderTabs() {
      tabsEl.innerHTML = '';
      if (products.length < 2) return;
      products.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cr-nutri__tab'; b.textContent = flavorsOf(p)[0].product;
        b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', p === state.product ? 'true' : 'false');
        b.addEventListener('click', function () { state.product = p; state.flavor = flavorsOf(p)[0].flavor; renderAll(); });
        tabsEl.appendChild(b);
      });
    }
    function renderVariants() {
      varsEl.innerHTML = '';
      flavorsOf(state.product).forEach(function (d) {
        if (!d.flavor) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cr-nutri__pill'; b.textContent = d.flavor;
        b.setAttribute('aria-pressed', d.flavor === current().flavor ? 'true' : 'false');
        b.addEventListener('click', function () { state.flavor = d.flavor; renderAll(); showFlavorPhoto(true); });
        varsEl.appendChild(b);
      });
    }
    function renderPanels() {
      root.querySelectorAll('[data-cr-nutri-panel]').forEach(function (el) { el.hidden = el.dataset.crNutriPanel !== state.product; });
      root.querySelectorAll('[data-cr-nutri-gallery]').forEach(function (el) { el.hidden = el.dataset.crNutriGallery !== state.product; });
      if (typeof window.CocoRockGallerySync === 'function') window.CocoRockGallerySync(root);
    }
    function renderBody() {
      var d = current();
      root.querySelector('[data-cr-nutri-desc]').textContent = d.desc || '';
      root.querySelector('[data-cr-nutri-ing]').textContent = d.ing || '';
      root.querySelector('[data-cr-nutri-portion]').textContent = d.portion || '';
      root.querySelector('[data-cr-nutri-col]').textContent = 'Porção';
      var tb = root.querySelector('[data-cr-nutri-rows]'); tb.innerHTML = '';
      d.rows.forEach(function (r) {
        var tr = document.createElement('tr');
        var val = r[1] === '' ? '—' : (r[1] || '—');
        var vd = r[2] === '' ? '—' : r[2] + '%';
        tr.innerHTML = '<td>' + r[0] + '</td><td>' + val + '</td><td class="cr-nutri__vd">' + vd + '</td>';
        tb.appendChild(tr);
      });
      var claims = root.querySelector('[data-cr-nutri-claims]');
      if (d.claims) { claims.hidden = false; claims.textContent = d.claims; } else { claims.hidden = true; }
      var av = root.querySelector('[data-cr-nutri-aviso]');
      if (d.aviso) { av.hidden = false; av.textContent = '⚠ ' + d.aviso; } else { av.hidden = true; }
    }
    function renderAll() { renderTabs(); renderVariants(); renderPanels(); renderBody(); }
    /* sabor escolhido → galeria vai para a foto dele (igual à página de produto e ao Quick View) */
    function showFlavorPhoto(animate) {
      var d = current();
      if (!d || typeof d.slide !== 'number' || d.slide < 0) return;
      var track = root.querySelector('[data-cr-nutri-gallery="' + state.product + '"] [data-cr-gallery-track]');
      if (!track) return;
      var smooth = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: d.slide * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }
    state.flavor = flavorsOf(state.product)[0].flavor;
    renderAll();
  }
  document.querySelectorAll('[data-cr-nutri]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-cr-nutri]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-cr-pdp]').forEach(function (root) {
    if (root.dataset.crPdpReady === 'true') return;
    root.dataset.crPdpReady = 'true';
    // galeria
    var mainImg = root.querySelector('[data-cr-pdp-main] img');
    root.querySelectorAll('[data-cr-pdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.full; }
        root.querySelectorAll('[data-cr-pdp-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    // quantidade
    var qtyInput = root.querySelector('[data-cr-qty-input]');
    if (qtyInput) {
      root.querySelector('[data-cr-qty-plus]').addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1); });
      root.querySelector('[data-cr-qty-minus]').addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    }

    // variantes
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-cr-variants]').textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-cr-variant-id]');
    var priceEl = root.querySelector('[data-cr-price]');
    var wasEl = root.querySelector('[data-cr-price-was]');
    var addBtn = root.querySelector('[data-cr-add-label]');
    var selected = [];
    var initialized = false;
    var shownVariant = null;
    root.querySelectorAll('[data-cr-option-index]').forEach(function (grp) {
      var i = parseInt(grp.dataset.crOptionIndex, 10);
      var active = grp.querySelector('[aria-pressed="true"]') || grp.querySelector('.cr-pdp__pill');
      selected[i] = active ? active.dataset.crOptValue : null;
      grp.querySelectorAll('.cr-pdp__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          grp.querySelectorAll('.cr-pdp__pill').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          selected[i] = pill.dataset.crOptValue;
          update();
        });
      });
    });
    function markUnavailable() {
      root.querySelectorAll('[data-cr-option-index]').forEach(function (grp) {
        var i = parseInt(grp.dataset.crOptionIndex, 10);
        grp.querySelectorAll('.cr-pdp__pill').forEach(function (pill) {
          var value = pill.dataset.crOptValue;
          var ok = variants.some(function (v) { return v.available && v.options[i] === value && v.options.every(function (o, k) { return k === i || selected[k] == null || o === selected[k]; }); });
          pill.dataset.unavailable = ok ? 'false' : 'true';
        });
      });
    }
    function money(cents) { return 'R$ ' + (cents / 100).toFixed(2).replace('.', ','); }
    function update() {
      var match = variants.find(function (v) {
        return v.options.every(function (o, k) { return selected[k] == null || o === selected[k]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (wasEl) { wasEl.hidden = !(match.compare > match.price); if (!wasEl.hidden) wasEl.textContent = money(match.compare); }
      var variantChanged = initialized && match.id !== shownVariant;
      shownVariant = match.id;
      if (variantChanged && match.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = match.image; }
      if (variantChanged && window.history && history.replaceState) { var url = new URL(window.location.href); url.searchParams.set('variant', match.id); history.replaceState(history.state, '', url); }
      markUnavailable();
      if (addBtn) { addBtn.textContent = match.available ? 'Adicionar ao carrinho' : 'Esgotado'; addBtn.disabled = !match.available; }
    }
    update();
    initialized = true;

    // Adicionar ao carrinho sem sair da página: envia por AJAX e abre o
    // carrinho lateral nativo do tema. Sem drawer no DOM, deixa o form seguir
    // o caminho normal (defensivo, não deveria acontecer com cart_type=drawer).
    var form = root.querySelector('form');
    var errEl = root.querySelector('[data-cr-pdp-error]');
    if (form) {
      form.addEventListener('submit', function (evt) {
        var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cartEl) return;
        evt.preventDefault();
        if (addBtn && addBtn.disabled) return;

        if (errEl) errEl.hidden = true;
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); addBtn.textContent = 'Adicionando...'; }

        /* Mesmo fluxo da Home e do combo: re-busca as seções se vierem incompletas e reaplica a Yever. */
        if (window.CocoRockCart && typeof window.CocoRockCart.addItems === 'function') {
          var qtyField = root.querySelector('[data-cr-qty-input]');
          var qtyValue = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
          window.CocoRockCart.addItems([{ id: Number(idInput.value), quantity: qtyValue }], addBtn, 'pdp')
            .catch(function (err) { if (errEl) { errEl.hidden = false; errEl.textContent = (err && err.message) || 'Não deu pra adicionar ao carrinho agora. Tenta de novo.'; } })
            .finally(function () { if (addBtn) addBtn.setAttribute('aria-busy', 'false'); update(); });
          return;
        }

        var formData = new FormData(form);
        if (cartEl.getSectionsToRender) {
          formData.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
          formData.append('sections_url', window.location.pathname);
        }
        if (cartEl.setActiveElement) cartEl.setActiveElement(document.activeElement);

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              if (errEl) { errEl.hidden = false; errEl.textContent = response.description || response.message || 'Não deu pra adicionar esse item agora.'; }
              return;
            }
            cartEl.renderContents(response);
          })
          .catch(function () {
            if (errEl) { errEl.hidden = false; errEl.textContent = 'Não deu pra adicionar ao carrinho agora. Tenta de novo.'; }
          })
          .finally(function () {
            if (addBtn) addBtn.setAttribute('aria-busy', 'false');
            update();
          });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-social-proof"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){if(!root||root.dataset.crProofReady==='true')return;root.dataset.crProofReady='true';
  var reduceQuery=window.matchMedia('(prefers-reduced-motion: reduce)'),reduce=reduceQuery.matches,viewport=root.querySelector('[data-cr-testi-viewport]');
  function cardStep(){var card=viewport&&viewport.querySelector('.cr-testi');if(!card)return 0;var track=viewport.querySelector('.cr-proof__testi-track'),gap=parseFloat(getComputedStyle(track).gap)||0;return card.getBoundingClientRect().width+gap}
  function go(direction){if(!viewport)return;var step=cardStep(),max=viewport.scrollWidth-viewport.clientWidth,next=viewport.scrollLeft+direction*step;if(direction>0&&next>max-4)next=0;if(direction<0&&next<0)next=max;viewport.scrollTo({left:next,behavior:reduce?'auto':'smooth'})}
  var prev=root.querySelector('[data-cr-testi-prev]'),next=root.querySelector('[data-cr-testi-next]');if(prev)prev.addEventListener('click',function(){go(-1)});if(next)next.addEventListener('click',function(){go(1)});
  /* arrasto com inércia e encaixe suave: cr-effects.js ([data-cr-drag-scroll]) */
  if(viewport&&typeof window.CocoRockDragScroll==='function')window.CocoRockDragScroll(viewport);

  var logoViewport=root.querySelector('[data-cr-logo-viewport]'),logoTrack=root.querySelector('[data-cr-logo-track]'),firstSet=logoTrack&&logoTrack.querySelector('.cr-proof__logo-set'),offset=0,last=performance.now(),logoDown=false,logoStart=0,offsetStart=0,frame=null,setWidth=0,visible=true,fling=0,lastLogoX=0,lastLogoT=0;
  function setOffset(value){var width=setWidth||(setWidth=firstSet?firstSet.getBoundingClientRect().width:0);if(!width)return;offset=value%width;if(offset<0)offset+=width;logoTrack.style.transform='translate3d('+(-offset)+'px,0,0)'}
  function tick(now){frame=null;if(!root.isConnected||reduce||!visible)return;if(!logoDown){var speed=parseFloat(root.dataset.logoSpeed)||28;/* depois de soltar o arrasto, a faixa desliza e desacelera até voltar à velocidade normal */if(Math.abs(fling)>0.02){setOffset(offset-fling*(now-last));fling*=0.94}else{fling=0;setOffset(offset+speed*(now-last)/1000)}}last=now;frame=requestAnimationFrame(tick)}
  function startLoop(){if(frame||reduce||!logoViewport||!logoTrack||!firstSet)return;last=performance.now();frame=requestAnimationFrame(tick)}
  function onReduceChange(){reduce=reduceQuery.matches;if(reduce&&frame){cancelAnimationFrame(frame);frame=null}else startLoop()}
  if(logoViewport&&logoTrack&&firstSet){logoViewport.addEventListener('pointerdown',function(event){logoDown=true;fling=0;logoStart=lastLogoX=event.clientX;lastLogoT=performance.now();offsetStart=offset;logoViewport.classList.add('is-dragging');logoViewport.setPointerCapture(event.pointerId)});logoViewport.addEventListener('pointermove',function(event){if(!logoDown)return;var t=performance.now();fling=0.8*((event.clientX-lastLogoX)/Math.max(1,t-lastLogoT))+0.2*fling;lastLogoX=event.clientX;lastLogoT=t;setOffset(offsetStart-(event.clientX-logoStart))});function logoUp(){logoDown=false;logoViewport.classList.remove('is-dragging')}logoViewport.addEventListener('pointerup',logoUp);logoViewport.addEventListener('pointercancel',logoUp);reduceQuery.addEventListener('change',onReduceChange);window.addEventListener('resize',function(){setWidth=0});if('IntersectionObserver' in window){new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;if(visible)startLoop()}).observe(logoViewport)}startLoop()}
  root.crProofCleanup=function(){if(frame)cancelAnimationFrame(frame);frame=null;reduceQuery.removeEventListener('change',onReduceChange);root.crProofCleanup=null};
}
function initAll(scope){(scope||document).querySelectorAll('[data-cr-proof]').forEach(init)}
initAll(document);document.addEventListener('shopify:section:load',function(event){initAll(event.target)});document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-cr-proof]').forEach(function(root){if(root.crProofCleanup)root.crProofCleanup()})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
